export const UserAccessOptions = Object.freeze({
    CHAT: 'CHAT',
    ADMIN: 'ADMIN',
});
